// extracted by mini-css-extract-plugin
module.exports =  {"Breadcrumbs":"z0KNd2HkHf8u5ibEYPPq","Breadcrumbs__Icon":"xoDSo5osbBhYf9vmMsbh"};